import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export const LoadInProgress = ({ loadValue, loadText, variant }) => {
    return (
        <div className="load-progress-box-wrapper" style={{ position: 'relative', width: 58, height: 58 }}>
            <CircularProgress
                variant={variant ? variant : 'determinate'}
                value={100}
                size={58}
                thickness={4}
                sx={{
                    color: '#EBF2FD',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                }}
            />

            <CircularProgress
                variant={variant ? variant : 'determinate'}
                value={loadValue}
                size={58}
                thickness={4}
                sx={{
                    color: '#0B5DCF',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                }}
            />
            <p className="load-progress-box">{loadText ? loadText : `${loadValue ? Math.round(loadValue) : 0}%`}</p>
        </div>
    );
};
